module.exports = __webpack_public_path__ + "static/fonts/PorscheNextPashtoTT-Regular.f4f353c3.ttf";